import { useQuery } from '@tanstack/react-query'

import type { IUser } from '@albacross/types'

import { isAlbacrossAdmin } from 'models/user-model'
import { get } from 'utils/http'

// Raw (snake_case) user + the derived `admin` boolean the views/edit form need (the API only exposes `type`).
export type UserDetail = IUser & { admin: boolean }

// Single-user detail. Keyed under 'user' (distinct from the 'users' list).
export const useUser = (userId: any) =>
  useQuery({
    queryKey: ['user', userId],
    queryFn: async (): Promise<UserDetail> => {
      const user = await get<IUser>(`/management/users/${userId}`)
      return { ...user, admin: isAlbacrossAdmin(user) }
    },
    staleTime: 60 * 60 * 1000,
  })
